<template>
  <el-container direction="vertical">
    <Top></Top>
    <el-container direction="horizontal" class="main-content">
      <SliderBar></SliderBar>
      <el-main class="scroll">
        <Crumb />
        <router-view />
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import Top from '@/components/common/Top'
import SliderBar from '@/components/common/SliderBar'
import Crumb from '@/components/common/Crumb'
export default {
  components: { Top, SliderBar, Crumb },
  computed: {}
}
</script>

<style lang="less">
.main-content {
  height: calc(100vh - 60px);
  max-height: calc(100vh - 60px);
  overflow: hidden;
  background: #f6f8fa;
}
</style>
